export enum Qualification {
    Education = 'education',
    WorkExperience = 'work-experience',
    VolunteerService = 'volunteer-service',
    LicenseAndCertifications = 'license-and-certifications',
    Tests = 'tests',
    Awards = 'awards'
}
